import styled from 'styled-components';
import { DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

export const FlagButton = styled.button`
  display: flex;
  margin-right: 6px;
  margin-left: ${props => (props.isfooter === 'true' ? '0' : '10px')};
  align-items: center;
  color: ${props => (props.isfooter === 'true' ? '#FFF' : '#007db8')}!important;
  cursor: pointer;
  font-size: ${props => (props.isfooter === 'true' ? '0.75rem' : '0.875rem')}!important;
  border: none;
  outline: none;
  box-shadow: none;
  line-height: 20px;
  background: transparent;
  padding: 0;

  @media (min-width: 1024px) {
    font-size: 0.875rem !important;
  }

  &:focus {
    outline: 1px dotted ${props => (props.isfooter === 'true' ? '#FFF' : '#212121')};
    outline: 5px auto -webkit-focus-ring-color;
  }
`;

export const FlagButtonImg = styled.img`
  display: inline-block;
  max-width: 100%;
  max-height: 25px;
  margin-right: 5px;
`;

export const DropdownToggleCustom = styled(DropdownToggle)`
  background-color: transparent;
  color: ${props => (props.isfooter === 'true' ? '#FFF' : '#007db8')};
  border: none;
  padding: 0;
  text-transform: capitalize;
  font-size: ${props => (props.isfooter === 'true' ? '0.75rem' : '0.875rem')};
  height: 25px;

  @media (min-width: 1024px) {
    font-size: 0.875rem;
  }

  &.btn-secondary {
    &[aria-expanded='true'],
    &:hover,
    &:active {
      background-color: transparent;
      color: ${props => (props.isfooter === 'true' ? '#FFF' : '#007db8')}!important;
      box-shadow: none;
    }

    &:focus,
    &:focus:active {
      background-color: transparent;
      color: ${props => (props.isfooter === 'true' ? '#FFF' : '#007db8')}!important;
      box-shadow: none;
      outline: 1px dotted ${props => (props.isfooter === 'true' ? '#FFF' : '#212121')};
      outline: 5px auto -webkit-focus-ring-color;
    }
  }
`;

export const DropdownMenuCustom = styled(DropdownMenu)`
  border: 1px solid #fff;
  background-color: #fff;
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.15);
  margin: 0;
  padding: 0;
  min-width: 100px;
`;

export const DropdownItemCustom = styled(DropdownItem)`
  color: #007db8;
  padding: 5px;
  font-size: ${props => (props.isfooter === 'true' ? '0.75rem' : '0.875rem')};
  margin: 0;
  max-width: 100%;

  @media (min-width: 1024px) {
    font-size: 0.875rem;
  }

  &:hover,
  &:focus,
  &:focus:active,
  &:active {
    background-color: #007db8;
    color: #fff;
    border: none;
    box-shadow: none;
  }
`;

export const SpanLanguage = styled.span`
  color: #007db8;
  text-transform: capitalize;
  font-size: 0.875rem;
  height: 25px;
  display: flex;
  align-items: center;
`;

export const AngleDownIcon = styled.span`
  transform: rotate(90deg);
  display: inline-block;
  font-size: 0.875rem;
  margin-left: 3px;
  position: relative;
  top: 1px;
`;
export const LocationLabel = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  > span {
    @media (min-width: 563px) {
      margin-bottom: -2px;
    }
  }
  &:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 .942a7.058 7.058 0 1 0 0 14.116A7.058 7.058 0 0 0 8 .942ZM1.908 8.47h2.304c.028.801.122 1.564.278 2.263H2.537a6.053 6.053 0 0 1-.629-2.263Zm6.563-4.145V2.03c.715.263 1.348 1.11 1.782 2.295H8.471Zm2.069.942c.17.692.278 1.458.309 2.262H8.471V5.267h2.068ZM7.53 2.03v2.295H5.748C6.183 3.14 6.816 2.293 7.53 2.03Zm0 3.237v2.262H5.152c.031-.804.14-1.57.31-2.262H7.53ZM4.212 7.529H1.908a6.06 6.06 0 0 1 .629-2.262H4.49c-.157.7-.251 1.461-.279 2.262Zm.94.941H7.53v2.263H5.462a11.35 11.35 0 0 1-.31-2.263Zm2.378 3.204v2.297c-.715-.264-1.347-1.112-1.782-2.297H7.53Zm.94 2.297v-2.297h1.783c-.435 1.186-1.067 2.033-1.782 2.297Zm0-3.238V8.47h2.379c-.031.805-.14 1.57-.31 2.263H8.472ZM11.79 8.47h2.304a6.06 6.06 0 0 1-.629 2.263h-1.953c.157-.7.25-1.462.278-2.263Zm0-.94a12.302 12.302 0 0 0-.278-2.263h1.953c.347.69.566 1.454.628 2.262h-2.303Zm1.089-3.205h-1.63c-.26-.79-.602-1.473-1.008-2.011a6.136 6.136 0 0 1 2.638 2.011ZM5.76 2.315c-.405.538-.747 1.22-1.007 2.01H3.122a6.14 6.14 0 0 1 2.638-2.01Zm-2.638 9.36h1.63c.26.79.602 1.472 1.007 2.01a6.136 6.136 0 0 1-2.637-2.01Zm7.119 2.01c.405-.538.748-1.22 1.007-2.011h1.63a6.131 6.131 0 0 1-2.637 2.011Z' fill='%23636363'/%3E%3C/svg%3E");
    filter: ${props => (props.isfooter === 'true' ? 'invert(100%) sepia(0%) saturate(2%) hue-rotate(64deg) brightness(230%) contrast(101%)' : 'invert(32%) sepia(95%) saturate(4383%) hue-rotate(181deg) brightness(95%) contrast(101%)')};
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 16px 16px;
    content: "";
    display: inline-block;
    height: 25px;
    margin-right: 4px;
    padding: 4px;
    width: 16px;
}
`;
